<template>
  <section class="page-title-wrap d-flex position-relative text-center over-bg" :class="{ active: active }">
    <svg xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 ' + winWFix + ' ' + wrapH" :style="wrapStyles">
      <defs>
        <linearGradient id="page2-a" x1="50%" x2="50%" y1="0%" y2="96.708%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="darkenMain"/>
        </linearGradient>
        <linearGradient id="page2-b" x1="50%" x2="50%" y1="0%" y2="96.708%" :gradientTransform="isSmall ? 'rotate(-30 0.5 0.5)' : ''">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="darkenMain"/>
        </linearGradient>
        <filter id="page2-c" width="110.6%" height="110.9%" x="-5.3%" y="-5.5%" filterUnits="objectBoundingBox">
          <feGaussianBlur in="SourceGraphic" stdDeviation="4.785"/>
        </filter>
        <linearGradient id="page2-d" x1="50%" x2="50%" y1="0%" y2="100%" :gradientTransform="isSmall ? 'rotate(135 0.5 0.5)' : ''">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="darkenMain"/>
        </linearGradient>
      </defs>

      <rect :width="winW + 2" x="-1" :height="wrapH" fill="url(#page2-a)"/>
      <circle
        style="opacity: 0"
        :cx="deskBigCircCx"
        :cy="isSmall ? ((wrapH / 2) - 333.5) + 294.536 : deskBigCircCy"
        fill="url(#page2-b)"
        fill-opacity=".7"
        filter="url(#page2-c)"
        :r="isSmall ? '135.169' : '202.114'"
        :transform="isSmall ? '' : 'rotate(-30 ' + deskBigCircCx + ' ' + deskBigCircCy + ')'"
        ref="mainCirc"
      />
      <circle
        style="opacity: 0"
        :cx="rightCx"
        :cy="rightCy"
        fill="url(#page2-d)"
        fill-opacity=".7"
        :r="isSmall ? 40.587 : 60"
        :transform="isSmall ? '' : 'rotate(-30 ' + (winWFix * 0.8) + ' ' + (wrapH * 0.82) + ')'"
        ref="rightCirc"
      />
      <circle
        style="opacity: 0"
        :cx="isSmall ? ((winW / 2) - 187.5) + 19.223 : winW / 4"
        :cy="isSmall ? ((wrapH / 2) - 333.5) + 150.223 : wrapH / 7"
        fill="url(#page2-d)"
        fill-opacity=".7"
        :r="isSmall ? '21.658' : '36'"
        :transform="isSmall ? '' : 'rotate(-30 ' + (winWFix / 4) + ' ' + ((wrapH / 7) - (wrapH * 0.1)) + ')'"
        ref="leftCirc"
      />
    </svg>

    <div class="position-absolute d-flex flex-column align-items-stretch w-75 title-text"
         :style="txtStyles">
      <header class="d-flex flex-column justify-content-end align-items-center pb-5 header-wrap">
        <h1
          class="mb-0 heading"
          v-html="head"
          ref="head"
          :style="{ letterSpacing: headSpace + 'em', paddingLeft: headSpace + 'em' }"
        ></h1>
        <span class="subhead" v-html="subhead" ref="sub"></span>
      </header>

      <div class="footer-wrap d-flex flex-column justify-content-center align-items-center">

        <h2
          class="mb-4 keyword"
          v-html="kw"
          ref="kw"
          :style="{ letterSpacing: kwSpace + 'em', paddingLeft: kwSpace + 'em' }"
        ></h2>

        <div class="numeral-wrap position-relative">
          <ring-vect ref="ring"/>

          <div class="dashes d-flex justify-content-center overflow-hidden position-absolute">
            <div class="inner position-absolute h-100" :style="{ borderLeft: '1px dashed ' + mainColor }"></div>
          </div>

          <span class="adobe-clean-serif-med numeral position-absolute absolute-center" ref="num"
                v-html="numeral"></span>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { TimelineMax, Back } from 'gsap'
  import { darken, shuffleArr } from '@/lib/funcs'
  import TitleMixin from '@/components/report/mixins/TitleMixin'

  export default {
    name: 'Title2',
    mixins: [ TitleMixin ],
    data () { return { tl: new TimelineMax() } },
    computed: {
      darkenMain () { return darken( this.mainColor, 1 - (64 / 255) ) },

      rightCx () { return this.isSmall ? ((this.winW / 2) - 187.5) + 357.637 : this.winWFix * 0.8 },

      rightCy () { return this.isSmall ? ((this.wrapH / 2) - 333.5) + 503.637 : this.wrapH * 0.82 }
    },
    methods: {
      setTweens () {
        this.tl.set( [ this.headSpans, this.kwSpans, this.$refs.sub, this.$refs.ring.$el, this.$refs.num ], { opacity: 0 } )
          .set( [ this.$refs.mainCirc, this.$refs.leftCirc, this.$refs.rightCirc ], { transformOrigin: '50% 50%' } )
          .set( this.$refs.mainCirc, { scale: 0.5 } )
          .set( [ this.$refs.ring.$el, this.$refs.leftCirc, this.$refs.rightCirc ], { scale: 0 } )
          .set( this.$refs.sub, { yPercent: 100 } )
      },
      tweenIn () {
        let headSpans = shuffleArr( [ ...this.headSpans ] )
        let kwSpans = shuffleArr( [ ...this.kwSpans ] )

        this.tl.to( this.$refs.mainCirc, this.time, { opacity: 1, scale: 1, ease: Back.easeOut.config( 1 ) }, 'in' )
          .to( this, this.time, { headSpace: 0.1 }, 'in' )
          .staggerTo( headSpans, this.time, { opacity: 1 }, this.stagger, 'in' )
          .to( this.$refs.sub, this.time, { opacity: 1, yPercent: 0 }, 'in' )
          .to( this, this.time, { kwSpace: 0.2666 }, 'in+=' + (this.stagger * 2) )
          .staggerTo( kwSpans, this.time, { opacity: 1 }, this.stagger, 'in+=' + (this.stagger * 2) )
          .to( this.$refs.ring.$el, this.time, { opacity: 1, scale: 1 }, 'in+=' + (this.stagger * 2) )
          .to( this.$refs.num, this.time / 2, { opacity: 1 }, 'in+=' + (this.stagger * 2 + (this.time / 2)) )
          .staggerTo( [ this.$refs.leftCirc, this.$refs.rightCirc ], this.time, {
            opacity: 1,
            scale: 1,
            ease: Back.easeOut.config( 1 )
          }, this.stagger * 2, 'in+=' + (this.stagger * 4) )
          .call( () => this.$emit( 'tween-done' ) )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/titleVects/Title2.vue